<script setup lang="ts">
import type { ILazyImageProps } from '~/interfaces/components/lazy-image';

const { getPlaceholder } = useBranding();

const props = withDefaults(defineProps<ILazyImageProps>(), {
  placeholder: '',
  class: '',
  style: '',
  alt: '',
  fetchPriority: 'auto',
  loading: 'lazy',
  showPlaceholder: true,
});

const bindings = {
  ...(props.showPlaceholder && {
    placeholder: props.placeholder || getPlaceholder('categoryCardPlaceholder'),
  }),
  ...(props.fetchPriority === 'high'
    ? {
        'fetch-priority': 'high',
        preload: true,
      }
    : { 'fetch-priority': props.fetchPriority }),
};
</script>

<template>
  <NuxtImg
    :class="[
      `text-center user-select-none text-base-priority truncate`,
      props.class,
    ]"
    v-bind="bindings"
    format="webp"
    provider="kentico"
    :loading="props.loading"
    :src="props.src"
    :style="props.style"
    :alt="props.alt || props.src"
    draggable="false"
    :original-src="props.src"
  />
</template>

<style scoped>
* {
  -webkit-user-drag: none;
}
</style>
